export default __webpack_public_path__ + "assets/models/ba500d86e78cd315dc62d099888a90f1.glb";